import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DataServiceService } from 'src/app/services/data-service.service';
import { ChartEmbedComponent } from "../../_components/chart-embed/chart-embed.component";

@Component({
    selector: 'app-sup-charts',
    templateUrl: './sup-charts.component.html',
    styleUrls: ['./sup-charts.component.scss'],
    imports: [ChartEmbedComponent]
})
export class SupChartsComponent implements OnInit {

  title="Investing for Catholics Supplemental Charts"

  chartId = 293;
  chartId2 = 297;

  constructor(private seoservice: SeoService, private meta: Meta, private route: ActivatedRoute, private service: DataServiceService) { }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
    this.meta.addTag({
      name: 'keywords',
      content: 'investing disclosures charts, investing for catholics disclosures charts, ifc supplemental charts'
    });
    this.meta.addTag({
      name: 'description',
      content: 'Supplemental charts and DISCLOSURES FOR THE HYPOTHETICAL BACKTESTED PERFORMANCE OF THE INVESTING FOR CATHOLICS MODEL INDEX PORTFOLIOS AND INDEXES.'
    });
    this.meta.addTag({
      name: 'author',
      content: 'Investing for Catholics'
    });
    this.meta.addTag({
      name: 'robots',
      content: 'index, follow'
    });

  }

}
